import { Module } from 'vuex';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';
import { StateInterface } from '@/interfaces/projects';
import { feedbackDetails } from '@/interfaces/feedback';


const feedbackDetailsModule: Module<feedbackDetails, StateInterface> = {
    namespaced: true,
    actions,
    getters,
    mutations,
    state
}


export default feedbackDetailsModule;